if (!customElements.get('lc-email-popup')) {
  customElements.define(
    'lc-email-popup',
    class LcEmailPopup extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'lc_popup_seen';
        this.exitHandler = this.onExitIntent.bind(this);
        this.fallbackTimer = null;
      }

      connectedCallback() {
        this.querySelectorAll('[data-lc-popup-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        this.addEventListener('click', (e) => {
          if (e.target === this) this.close();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !this.hidden) this.close();
        });

        if (this.dataset.posted === 'true') {
          this.show();
          return;
        }

        if (this.hasBeenSeen()) return;

        document.addEventListener('mouseleave', this.exitHandler);
        this.fallbackTimer = setTimeout(() => this.show(), 20000);
      }

      hasBeenSeen() {
        try {
          return localStorage.getItem(this.storageKey) === 'true';
        } catch (e) {
          return false;
        }
      }

      markSeen() {
        try {
          localStorage.setItem(this.storageKey, 'true');
        } catch (e) {
          /* private mode or blocked storage: no-op */
        }
      }

      onExitIntent(e) {
        if (e.clientY <= 0) this.show();
      }

      show() {
        if (!this.hidden) return;
        document.removeEventListener('mouseleave', this.exitHandler);
        if (this.fallbackTimer) clearTimeout(this.fallbackTimer);
        this.hidden = false;
        this.markSeen();
      }

      close() {
        this.hidden = true;
      }
    }
  );
}
